import React from 'react';

/** Badge breve para pedidos recién ingresados a la cola del médico. */
export default function PedidoNuevoBadge({ show }) {
  if (!show) return null;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 7px',
        borderRadius: 999,
        fontSize: 9,
        fontWeight: 800,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        background: 'linear-gradient(180deg,#ecfdf5,#d1fae5)',
        color: '#15803d',
        border: '1px solid rgba(22,163,74,.35)',
        boxShadow: '0 0 0 2px rgba(34,197,94,.12)',
        flexShrink: 0,
        lineHeight: 1.2
      }}
    >
      Nuevo
    </span>
  );
}
